module.exports = __webpack_public_path__ + "img/chinesecompany05.f29d509d.png";